import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaStar } from "react-icons/fa";
import { isAbortError, listFavouriteJobs, removeFavouriteJob } from "../../services/apiClient.js";

// FAVOURITE JOBS (Robert 2026-09-02): up to three pinned jobs as dismissible
// chips riding the header band after the Archive chip — "great for testing",
// and the office works the same way, a few hot jobs opened over and over.
// Same dismissible-chip language as the Needs Attention header filter
// (JobList.jsx): click opens the job's Details, the × unpins.
//
// Pinning happens on the job itself (the ☆ beside the job number in the rail,
// ClaimWorkspace). The two components talk through one window event so a pin
// made on a job is in the header band the moment you navigate back — no shared
// store for what is two widgets and three rows of data.
export const FAVOURITES_CHANGED = "cd:favourites-changed";
export const announceFavouritesChanged = (list) =>
  window.dispatchEvent(new CustomEvent(FAVOURITES_CHANGED, { detail: list }));

function FavouriteJobChips() {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);

  useEffect(() => {
    const controller = new AbortController();
    listFavouriteJobs({ signal: controller.signal })
      .then(setRows)
      .catch((err) => {
        if (!isAbortError(err)) setRows([]); // a failed load renders as no chips, never as an error band
      });
    const onChange = (e) => { if (Array.isArray(e.detail)) setRows(e.detail); };
    window.addEventListener(FAVOURITES_CHANGED, onChange);
    return () => {
      controller.abort();
      window.removeEventListener(FAVOURITES_CHANGED, onChange);
    };
  }, []);

  if (rows.length === 0) return null;
  return (
    <>
      {rows.map((r) => (
        <span
          key={r.claim_id}
          role="button"
          className="job-badge job-badge-fav"
          data-hint={[r.client_name, r.street_address].filter(Boolean).join(" — ") || undefined}
          onClick={() => navigate(`/claims/${r.claim_number}`)}
        >
          <FaStar size={10} className="fav-star" style={{ marginTop: -2 }} /> {r.claim_number}{" "}
          <span
            aria-label={`Unpin ${r.claim_number}`}
            data-hint={`Remove #${r.claim_number} from favourites`}
            role="button"
            onClick={(e) => {
              e.stopPropagation(); // the × unpins; it must not ALSO open the job
              removeFavouriteJob(r.claim_id).then(announceFavouritesChanged).catch(() => {});
            }}
          >
            ×
          </span>
        </span>
      ))}
    </>
  );
}

export default FavouriteJobChips;
